import PropTypes from 'prop-types'
import React from 'react'
import { ListGroup } from 'react-bootstrap'
import Session from './Session'

function SessionList(props) {
  const { actions, comments, onDelete, sessions } = props
  return (
    <ListGroup>
      {sessions.map(session => (
        <Session
          key={session.id}
          actions={actions}
          comments={comments}
          onDelete={onDelete}
          session={session}
        />
      ))}
    </ListGroup>
  )
}

SessionList.propTypes = {
  actions: PropTypes.bool.isRequired,
  comments: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  sessions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

SessionList.defaultProps = {
  actions: true,
  comments: true,
}

export default SessionList
